import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { subjectInsUpdSlice, selectSubjectInsUpd } from "../../../../redux/curriculum/subjectInsUpdSlice";
import { useAppDispatch } from "../../../../app/hooks";
import AvatarUploadDragAndDrop from "../../../../features/base/image/AvatarUploadDragAndDrop";

export function SubjectInsUpdData() {
    const subjectInsUpd = useSelector(selectSubjectInsUpd);
    const dispatch = useAppDispatch();

    const changedName = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const subject = {
            ...subjectInsUpd.subject
        };
        subject.name = event.target.value;
        dispatch(subjectInsUpdSlice.actions.set(subject));
    };

    const handleAvatarChange = (img: string) => {
        const subject = {
            ...subjectInsUpd.subject,
            url: img
        };
        dispatch(subjectInsUpdSlice.actions.set(subject));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da matéria
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={subjectInsUpd.subject.name}
                    onChange={changedName} />
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={subjectInsUpd.subject.url || ""}
                    onChange={handleAvatarChange}
                    alt={subjectInsUpd.subject.name}
                />
            </Grid>
        </Grid>
    </>;
}
